var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZondiconsLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0016 24C12.0016 24 3.60156 13.044 3.60156 8.4C3.60156 7.2969 3.81884 6.20459 4.24097 5.18546C4.66311 4.16632 5.28185 3.24032 6.06187 2.4603C6.84188 1.68029 7.76789 1.06155 8.78702 0.639412C9.80616 0.217272 10.8985 0 12.0016 0C13.1047 0 14.197 0.217272 15.2161 0.639412C16.2352 1.06155 17.1612 1.68029 17.9413 2.4603C18.7213 3.24032 19.34 4.16632 19.7622 5.18546C20.1843 6.20459 20.4016 7.2969 20.4016 8.4C20.4016 13.044 12.0016 24 12.0016 24ZM12.0016 10.8C12.6381 10.8 13.2485 10.5471 13.6986 10.0971C14.1487 9.64697 14.4016 9.03652 14.4016 8.4C14.4016 7.76348 14.1487 7.15303 13.6986 6.70294C13.2485 6.25286 12.6381 6 12.0016 6C11.365 6 10.7546 6.25286 10.3045 6.70294C9.85442 7.15303 9.60156 7.76348 9.60156 8.4C9.60156 9.03652 9.85442 9.64697 10.3045 10.0971C10.7546 10.5471 11.365 10.8 12.0016 10.8Z",
    fill: "#717780"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZondiconsLocation);
export default __webpack_public_path__ + "static/media/zondicons_location.e57e3fc3fcd7e32780e992b3f0b2c098.svg";
export { ForwardRef as ReactComponent };